import {
  memo,
  type FC
} from 'react';
import {
  Stack,
  Typography,
  styled
} from '@mui/joy';
import {
  CoinImage
} from '@shared/ui';
import {
  CurrencyCodesEnum
} from '@shared/types';
import {
  CoinPackageVariantEnum
} from '../lib';
import {
  ChosenCoinPackageFreeSweepCoinLabel
} from './chosen-coin-package-free-sweep-coin-label.component';

const CardLabel = styled(Typography)(() => ({
  fontSize: 14,
  fontWeight: 700,
  fontStyle: 'normal',
  lineHeight: '20px',
  textAlign: 'center'
}));

export type ChosenCoinPackageSummaryProps = {
  smallLabel?: boolean;
  redeemableCoinAmount: number;
  nonRedeemableCoinAmount: number;
  variant: CoinPackageVariantEnum;
};

export const ChosenCoinPackageSummary: FC<ChosenCoinPackageSummaryProps> = memo(({
  variant,
  smallLabel,
  redeemableCoinAmount,
  nonRedeemableCoinAmount
}) => (
  <Stack gap={1} justifyContent='flex-end'>
    {nonRedeemableCoinAmount && (
      <Stack
        direction='row'
        alignItems='center'
        gap={1}>
        <CoinImage
          code={CurrencyCodesEnum.GCO}
          sx={{ height: 16, width: 16 }}
        />
        <CardLabel>
          {nonRedeemableCoinAmount}
        </CardLabel>
      </Stack>
    )}
    {redeemableCoinAmount && (
      <Stack
        gap={1}
        direction='row'
        alignItems='center'>
        <CoinImage
          code={CurrencyCodesEnum.SCO}
          sx={{ height: 16, width: 16 }}
        />
        <CardLabel>
          {redeemableCoinAmount}
        </CardLabel>
        <ChosenCoinPackageFreeSweepCoinLabel
          variant={variant}
          smallLabel={smallLabel}
        />
      </Stack>
    )}
  </Stack>
));